import React, { Component } from 'react';
import { connect } from 'react-redux';
import reduxMount from '../../jsCore/utils/reduxMounter';
import { MOUNT_POINTS, } from '../../jsCore/config/preRenderedSelectorsConfig';
import { scoresTableReducer } from './scoresTableReducer';
import { scoresTableActions } from './scoresTableActions';
import { getNoEndpointsErrorMessage } from '../../jsCore/application/sagas/fetchSaga';
import { ScoresTable } from './components/scoresTable';

const COMPONENT_NAME = "scoresTable";
const STATE_KEY = "scoresTable";

function shouldShowScoresTable(table) {
  return table && table.teams && table.teams.length;
}

export class scoresTable extends Component {
  componentWillMount(){
    const { IS_INITIALIZED, IS_ENTRY_POINT_MISSING, fetchScoresTables } = this.props;
    if (IS_ENTRY_POINT_MISSING) {
      return getNoEndpointsErrorMessage(this);
    }
    if (IS_INITIALIZED) {
      return true;
    }
    fetchScoresTables();
  }

  getTableView() {
    const { tables, selectedLeague, IS_INITIALIZED } = this.props;
    return IS_INITIALIZED && shouldShowScoresTable(tables[selectedLeague]) ? (
      <ScoresTable table={ tables[selectedLeague] }/>
    ) : false;
  }
  render(){
    return this.getTableView();
  }
}

function mapStateToProps(state) {
  const { tables, IS_INITIALIZED, IS_ENTRY_POINT_MISSING, fetchScoresTables } = state[STATE_KEY];
  const { leagueId: selectedLeague } = state.scheduleComponent;
  return { tables, IS_INITIALIZED, IS_ENTRY_POINT_MISSING, selectedLeague, fetchScoresTables };
}


const scoresTableContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: connect(mapStateToProps, scoresTableActions)(scoresTable),
  reducer: scoresTableReducer
};

export default function mountScoresTable(...predicates){
  reduxMount({
    [MOUNT_POINTS.SCORES_TABLE]: scoresTableContainer,
  });
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/scores_table/scoresTableContainer.js